// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AnalyticsController from "./analytics_controller"
application.register("analytics", AnalyticsController)

import AttributeToggleController from "./attribute_toggle_controller"
application.register("attribute-toggle", AttributeToggleController)

import AxeptioController from "./axeptio_controller"
application.register("axeptio", AxeptioController)

import BarChartController from "./bar_chart_controller"
application.register("bar-chart", BarChartController)

import BarStackedChartController from "./bar_stacked_chart_controller"
application.register("bar-stacked-chart", BarStackedChartController)

import CheckboxStateManagerController from "./checkbox_state_manager_controller"
application.register("checkbox-state-manager", CheckboxStateManagerController)

import CleanInputController from "./clean_input_controller"
application.register("clean-input", CleanInputController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ConfirmRadioChangeController from "./confirm_radio_change_controller"
application.register("confirm-radio-change", ConfirmRadioChangeController)

import ConfirmToEnableController from "./confirm_to_enable_controller"
application.register("confirm-to-enable", ConfirmToEnableController)

import DependentCheckboxesController from "./dependent_checkboxes_controller"
application.register("dependent-checkboxes", DependentCheckboxesController)

import DetectOverflowController from "./detect_overflow_controller"
application.register("detect-overflow", DetectOverflowController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DispatchEventController from "./dispatch_event_controller"
application.register("dispatch-event", DispatchEventController)

import DisplayToggleController from "./display_toggle_controller"
application.register("display-toggle", DisplayToggleController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import DropdownFloatingController from "./dropdown_floating_controller"
application.register("dropdown-floating", DropdownFloatingController)

import EnableWhenFilledController from "./enable_when_filled_controller"
application.register("enable-when-filled", EnableWhenFilledController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FormValidationLandingController from "./form_validation_landing_controller"
application.register("form-validation-landing", FormValidationLandingController)

import HighlightController from "./highlight_controller"
application.register("highlight", HighlightController)

import HovercardController from "./hovercard_controller"
application.register("hovercard", HovercardController)

import ImgDelayedLoadController from "./img_delayed_load_controller"
application.register("img-delayed-load", ImgDelayedLoadController)

import Integrations__MapsController from "./integrations/maps_controller"
application.register("integrations--maps", Integrations__MapsController)

import LodViewerController from "./lod_viewer_controller"
application.register("lod-viewer", LodViewerController)

import ThreeDRemoteViewerController from "./three_d_remote_viewer_controller"
application.register("three-d-remote-viewer", ThreeDRemoteViewerController)

import MapAddressConfirmController from "./map_address_confirm_controller"
application.register("map-address-confirm", MapAddressConfirmController)

import MapRenderBuildingController from "./map_render_building_controller"
application.register("map-render-building", MapRenderBuildingController)

import NeedsPrioritySortController from "./needs_priority_sort_controller"
application.register("needs-priority-sort", NeedsPrioritySortController)

import PhoneInputController from "./phone_input_controller"
application.register("phone-input", PhoneInputController)

import PieChartController from "./pie_chart_controller"
application.register("pie-chart", PieChartController)

import PostMessageController from "./post_message_controller"
application.register("post-message", PostMessageController)

import PostMessageToParentController from "./post_message_to_parent_controller"
application.register("post-message-to-parent", PostMessageToParentController)

import RemoveBlockController from "./remove_block_controller"
application.register("remove-block", RemoveBlockController)

import ReplaceStateController from "./replace_state_controller"
application.register("replace-state", ReplaceStateController)

import ScrollIntoMeController from "./scroll_into_me_controller"
application.register("scroll-into-me", ScrollIntoMeController)

import ScrollStepsController from "./scroll_steps_controller"
application.register("scroll-steps", ScrollStepsController)

import ScrollToFirstController from "./scroll_to_first_controller"
application.register("scroll-to-first", ScrollToFirstController)

import SelectorController from "./selector_controller"
application.register("selector", SelectorController)

import SelfDestructController from "./self_destruct_controller"
application.register("self-destruct", SelfDestructController)

import SetInputValueController from "./set_input_value_controller"
application.register("set-input-value", SetInputValueController)

import SimulatorResultsLoaderController from "./simulator_results_loader_controller"
application.register("simulator-results-loader", SimulatorResultsLoaderController)

import SimulatorStreetViewController from "./simulator_street_view_controller"
application.register("simulator-street-view", SimulatorStreetViewController)

import SliderController from "./slider_controller"
application.register("slider", SliderController)

import StreetViewController from "./street_view_controller"
application.register("street-view", StreetViewController)

import SubmitFormController from "./submit_form_controller"
application.register("submit-form", SubmitFormController)

import SvgTextChangerController from "./svg_text_changer_controller"
application.register("svg-text-changer", SvgTextChangerController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import UploadXmlController from "./upload_xml_controller"
application.register("upload-xml", UploadXmlController)

import ValueToggleController from "./value_toggle_controller"
application.register("value-toggle", ValueToggleController)

import VisitController from "./visit_controller"
application.register("visit", VisitController)

import WorkPlanRecommendationFormController from "./work_plan_recommendation_form_controller"
application.register("work-plan-recommendation-form", WorkPlanRecommendationFormController)
